import React from "react";
import {
    Tabs,
    TabsHeader,
    TabsBody,
    Tab,
    TabPanel,
} from "@material-tailwind/react";
import {ContentNav} from "../../services/interface/content-nav";
import {useTranslation} from "react-i18next";

interface Props {
    nav: string;
    setNav: React.Dispatch<React.SetStateAction<string>>;
    content: ContentNav[];
}

export default function CustomNav({nav, setNav, content}: Props) {
    const { t } = useTranslation("global") as { t: (key: string) => string };

    return (
        <Tabs value={nav}>
            <TabsHeader placeholder={'tab-header'}
                className="rounded-none border-b border-blue-gray-50 bg-transparent p-0"
                indicatorProps={{
                    className:
                        "bg-transparent border-b-2 border-header shadow-none rounded-none",
                }}
            >
                {content.map(({ label, id }, index) => (
                    <Tab
                        placeholder={`tab-item-${index}`}
                        key={id}
                        value={id}
                        onClick={() => setNav(id)}
                        className={nav === id ? "text-header" : ""}
                    >
                        {t(label)}
                    </Tab>
                ))}
            </TabsHeader>
            <TabsBody placeholder={'tab-body'}>
                {content.map(({ id, desc }) => (
                    <TabPanel key={id} value={id} className={'px-0'}>
                        {desc}
                    </TabPanel>
                ))}
            </TabsBody>
        </Tabs>
    );
}
